export default "__VITE_ASSET__D5PQ0TVW__"